import { Box, Typography } from "@mui/material"
import { ShopItemList } from "./ShopItemList";
import { useEffect, useState } from "react";
import { MyListApi } from "../../utils/restApi";

export const Shop = () => {

    const [shopItems, setShopItems] = useState([
        // {
        //     name: 'Item 1',
        // },
        // {
        //     name: 'Item 2',
        // },
        // {
        //     name: 'Item 3',
        // },
        // {
        //     name: 'Item 4',
        // },
        // {
        //     name: 'Item 5',
        // },
    ]);

    useEffect(() => {
        MyListApi.getItems3({
            userId: null,
            tag: 'site-goods',
        }).then(data => {
            // console.log('data', data);
            setShopItems(data.data.items);
        }).catch(error => {
            // console.log('error', error);
        });
    }, []);

    return (
        <Box>
            <ShopItemList shopItems={shopItems} />
        </Box>
    );
}